/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".element[_ngcontent-%COMP%]{cursor:pointer;white-space:nowrap;display:inline-block;color:#161c2d}"];
export { styles as styles };
